import { Injectable } from '@angular/core';
import { PesquisaBaseComponent } from './pesquisa-base/pesquisa-base.component';

@Injectable()
export class PesquisaBaseService {

  componente: PesquisaBaseComponent | null= null;

  constructor() { }

  setarComponenteBase(componente: PesquisaBaseComponent) {
    this.componente = componente;
  }

  abrir() {
    if(this.componente === null) throw  'this.componente is null.';

    this.componente.abrir();
  }

  abrirTelaCheia() {
    if(this.componente === null) throw  'this.componente is null.';

    this.componente.abrirTelaCheia();
  }

  fechar() {
    if(this.componente === null) throw  'this.componente is null.';

    this.componente.fechar();
  }
}
